<template>
  <el-submenu
    v-if="!data.fullUrl&&data.children && data.children.length && data.isShow === 0"
    class="u-level-2"
    :title="data.name"
    :index="data.menuId"
  >
    <menu-item
      v-for="(sub, index) in data.children"
      :key="index"
      :data="sub"
      no-icon
    ></menu-item>
  </el-submenu>
  <el-menu-item
    v-else
    v-show="data.isShow === 0"
    :index="data.menuId"
  >
    {{ data.name }}
  </el-menu-item>
</template>

<script>
export default {
  name: 'menu-item',
  props: {
    data: Object,
    noIcon: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      defaultIcon: `this.src="${require('../../assets/images/nav_icondefault_B.png')}"`
    }
  }
}
</script>
